import React from "react";
import Skeleton from "react-loading-skeleton";
import { useDesign } from "../../../../context/DesignContext";

const StayUpToDateSkeleton = ({
  designTokens,
  blockArray = 3,
  isDashboard,
}: {
  designTokens?: any;
  blockArray?: any;
  isDashboard?: boolean;
}) => {
  const { templateName, primaryColor } = useDesign();

  const useNeutralLoader = isDashboard ||
    designTokens?.templateName?.toLowerCase() === "default" ||
    templateName?.toLowerCase() === "default";



  function SkeletonStatBox() {
    return (
      <Skeleton
        className="stayUpToDate-skeleton"
        baseColor={useNeutralLoader ? "#ededed" : primaryColor || designTokens?.primaryColor}
        highlightColor={useNeutralLoader ? "#ededed" : primaryColor || designTokens?.primaryColor}
        style={
          !useNeutralLoader && designTokens?.primaryColor
            ? {
                border: `1px solid ${designTokens?.tertiaryColor ? designTokens?.tertiaryColor : "#e6e7eb"}`,
              }
            : {}
        }
      />
    );
  }

  return (
    <>
      {[...Array(blockArray)].map((_, index) => (
        <SkeletonStatBox key={index} />
      ))}
    </>
  );
};

export default StayUpToDateSkeleton;
